module.exports = __webpack_public_path__ + "560f2650c6db7020c997ae411562096d.png";